let settings = {
    server: 'https://www.' + process.env.VUE_APP_BASE_DOMAIN,
    apiBaseUrl: 'https://www.' + process.env.VUE_APP_BASE_DOMAIN + '/rest',
    gtm: process.env.VUE_APP_GTM,
    csrfcookiename: process.env.CSRF_COOKIE_NAME,
}
export default settings

